import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import { Card, CardContent } from '@/components/ui/card';
import { Search, Mail, Phone, AlertCircle, CheckCircle2 } from 'lucide-react';

const TrackStatus = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <button
          onClick={() => navigate('/knowledge-base/processing-times')}
          className="text-primary hover:text-primary/80 transition-colors mb-8 flex items-center"
        >
          ← Back to Processing Times
        </button>

        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground mb-4">
            How to Track Your Application Status
          </h1>
          <p className="text-muted-foreground">
            A comprehensive guide to checking the progress of your residence permit application in Poland.
          </p>
        </div>

        <div className="space-y-8">
          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <Search className="h-5 w-5 text-primary mr-2" />
                Online Tracking Methods
              </h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <CheckCircle2 className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  <div>
                    <span className="font-semibold">Official Website:</span> Visit your voivodeship office's website and use their online tracking system
                  </div>
                </li>
                <li className="flex items-start">
                  <CheckCircle2 className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  <div>
                    <span className="font-semibold">E-PUAP Platform:</span> Track through the national e-government platform
                  </div>
                </li>
                <li className="flex items-start">
                  <CheckCircle2 className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  <div>
                    <span className="font-semibold">SMS Updates:</span> Register for SMS notifications about your application status
                  </div>
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <Phone className="h-5 w-5 text-primary mr-2" />
                Contact Methods
              </h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Call the Immigration Office helpline
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Send a written inquiry by post (must be in Polish)
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Contact your assigned case inspector directly
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Visit the office during designated hours
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <AlertCircle className="h-5 w-5 text-primary mr-2" />
                Important Information
              </h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Keep your case number and tracking credentials safe
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Respond promptly to any requests for additional documents
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  All official correspondence will be in Polish
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Update your contact information if it changes
                </li>
              </ul>
            </CardContent>
          </Card>

          <div className="bg-accent p-6 rounded-lg border border-border">
            <h2 className="text-xl font-semibold text-foreground mb-2">Lost Your Tracking Access?</h2>
            <p className="text-muted-foreground mb-4">
              If you've lost your tracking credentials or didn't receive them, you can request new access through your voivodeship office's website.
            </p>
            <button 
              onClick={() => navigate('/contact')}
              className="bg-primary text-primary-foreground px-6 py-2 rounded-lg hover:bg-primary/90 transition-colors"
            >
              Contact Support
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrackStatus; 